import {InlineBannerProps, InlineBannerType} from 'ui-library/banners/InlineBanner';

export function buildPreviewOverRowLimitMessage(rowLimit: number, extraMessage?: string): InlineBannerProps {
  return {
    bannerType: InlineBannerType.INFO,
    text: `This is a preview of the first ${rowLimit.toLocaleString()} rows.${
      extraMessage != null ? ` ${extraMessage}` : ''
    }`,
  };
}

export function buildPreviewFailureMessage(
  suggestedNextStep: string = 'Reach out to support@benchling.com if the issue persists.'
): InlineBannerProps {
  return {
    bannerType: InlineBannerType.ERROR,
    text: `A preview table could not be generated. ${suggestedNextStep}`,
  };
}

export function finalizationFailureMessage(): string {
  return 'The table could not be created. Please try again or reach out to support@benchling.com if the issue persists.';
}
